import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';

const EmployeeManagementPage = lazy(
  () => import('@/features/user-access/pages/employee-management/index')
);
const EmployeeManagementFormPage = lazy(
  () => import('@/features/user-access/pages/employee-management/form')
);

const RoleManagementPage = lazy(
  () => import('@/features/user-access/pages/role-management/index')
);
const RoleManagementFormPage = lazy(
  () => import('@/features/user-access/pages/role-management/form')
);

const LocationPage = lazy(
  () => import('@/features/user-access/pages/location/index')
);
const LocationFormPage = lazy(
  () => import('@/features/user-access/pages/location/form')
);

export const userAccessRoute = [
  {
    path: '/user-access/employee-management',
    Component: EmployeeManagementPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/employee-management/form',
    Component: EmployeeManagementFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/employee-management/form/:id',
    Component: EmployeeManagementFormPage,
    loader: combineLoaders(permissionsLoader),
  },

  {
    path: '/user-access/role-management',
    Component: RoleManagementPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/role-management/form',
    Component: RoleManagementFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/role-management/form/:id',
    Component: RoleManagementFormPage,
    loader: combineLoaders(permissionsLoader),
  },

  {
    path: '/user-access/location',
    Component: LocationPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/location/form',
    Component: LocationFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/user-access/location/form/:id',
    Component: LocationFormPage,
    loader: combineLoaders(permissionsLoader),
  },
];
